import { useEffect, useState } from "react";
import { useDocumentTitle } from "../../hooks";
import BackendLayout from "../../layouts/BackendLayout";
import { useDispatch } from "react-redux";
import { getDepartmentMasterImportPageSettings } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { DEPARTMENT_MASTER_IMPORT } from "../../constants/routes";
import {PageTitle, RedirectAlert} from "../../components";
import {
  resetAlert,
  setImportFileAlertError,
  setAlertError,
  setAlertSuccess,
  setPageLoading,
  clearPageLoading,
  setButtonProcessing,
  clearButtonProcessing
} from "../../store/actions";
import { importDepartments } from "../../api/department/departmentImportApi";
import { errorStatusHandle } from "../../utils/error-utils";
import { API_GET_DEPARTMENT_MASTER_DOWNLOAD_TEMPLATE_PAGE } from "../../constants/api";
import {
  FileTemplateDownloader,
  FileUploader,
} from "../../components/file-management";
import PageAlert from "../../components/alerts/PageAlert";
import { MAX_IMPORT_FILE_SIZE } from "../../constants/app";
import { convertBytesToMB } from "../../utils/common-utils";
import { ERROR_IMPORT_FILE_SIZE } from "../../constants/error";
import {DEPARTMENT_MASTER_IMPORT_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

const DepartmentMasterImportPage = () => {
  useRedirectPage(DEPARTMENT_MASTER_IMPORT_PAGE);
  const [selectedFile, setSelectedFile] = useState(null);
  const dispatch = useDispatch();
  useDocumentTitle("部門マスタインポート - 点検王");
  const breadcrumb = getRouteBreadcrumb(DEPARTMENT_MASTER_IMPORT);

  //Function help to set page settings
  const setDepartmentMasterImportPageSettings = async (e) => {
    dispatch(setPageLoading());
    const pageSettings = await getDepartmentMasterImportPageSettings();
    dispatch(setPageSettings(pageSettings));
    dispatch(clearPageLoading());
  };

  useEffect(() => {
    setDepartmentMasterImportPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeFileChange = (file) => {
    setSelectedFile(file);
    dispatch(resetAlert());
  };

  const BUTTON_IMPORT_DEPARTMENT = 'button__import-department';
  const handleUpload = () => {
    if (selectedFile !== null) {
      if (convertBytesToMB(selectedFile.size) > MAX_IMPORT_FILE_SIZE) {
        dispatch(setAlertError(ERROR_IMPORT_FILE_SIZE));
        return;
      }
    }
    dispatch(setButtonProcessing(BUTTON_IMPORT_DEPARTMENT));
    dispatch(resetAlert());
    const formData = new FormData();
    formData.append("file", selectedFile);
    importDepartments(formData)
      .then((response) => {
        dispatch(setAlertSuccess(response.message));
        setSelectedFile(null);
      })
      .catch((error) => {
        errorStatusHandle(error);
        if (error.status === 400) {
          let responseData = error.data;
          dispatch(setImportFileAlertError(responseData));
        }
      }).finally(() => {
        dispatch(clearButtonProcessing(BUTTON_IMPORT_DEPARTMENT));
    });
  };

  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="部門マスタインポート" />
      <RedirectAlert />
      <PageAlert />
      <div className="lg:flex mt-6 2xl:space-x-[32px] xl:space-x-[28px] lg:space-x-[24px] lg:space-y-0 md:space-y-[24px]">
        <FileUploader
          title="ファイルをアップロード"
          description="部門を更新するテンプレートファイルをアップロードしてください"
          file={selectedFile}
          handleUpload={handleUpload}
          handleChangeFileChange={handleChangeFileChange}
          buttonId={BUTTON_IMPORT_DEPARTMENT}
        />
        <FileTemplateDownloader
          title="テンプレートファイル"
          description="テンプレートファイルを持っていない場合、インポートに使用するファイルをこちらからダウンロードしてください。"
          apiUrl={API_GET_DEPARTMENT_MASTER_DOWNLOAD_TEMPLATE_PAGE}
        />
      </div>
    </BackendLayout>
  );
};

export default DepartmentMasterImportPage;
